import {
  DepartmentSizeQueryFilter,
  EventQueryFilter,
  QueryFilter,
} from "@/types/campaign";
import { PanelTop } from "lucide-react";
import { getFilterByFilterName, type FilterCategory } from "../config";
import { createFilterGroup, filterGroupTypes } from "../filter-types";

const createDisplayValue = (
  filterName: string,
  filters: (QueryFilter | EventQueryFilter | DepartmentSizeQueryFilter)[],
) => {
  const filter = getFilterByFilterName(filterName, filters);
  if (!filter) return "Ikke angivet";
  return filter.operator === "HasLabel" ? "Ja" : "Nej";
};

export const websiteFilterCategory = {
  id: "website",
  icon: PanelTop,
  title: "Hjemmesideoplysninger",
  description: "Indhold fra virksomhedernes hjemmesider",
  isAdvancedFilter: true,
  filters: {
    b2bTrading: createFilterGroup({
      id: "b2b-trading",
      title: "B2B - handler med erhverv",
      keywords: ["business to business", "firmaer", "ai"],
      description:
        "Viser om virksomhederne handler med andre virksomheder (B2B). Fundet ved hjælp af AI.",
      filterType: filterGroupTypes.label,
      yesLabel: "Handler med erhverv (B2B)",
      noLabel: "Handler ikke med erhverv (B2B)",
      values: ["8f63365f-97e7-4e60-82c6-0db7b8b6a183"], // "Handler med andre virksomheder (B2B)"
      filters: {
        value: {
          fieldName: "Labels.Labels",
          filterName: "website-label-b2b",
        },
      },
      DisplayValue: ({ filters }) => {
        return createDisplayValue("website-label-b2b", filters);
      },
    }),
    b2cTrading: createFilterGroup({
      id: "b2c-trading",
      title: "B2C - handler med private",
      keywords: ["business to consumer", "forbrugere", "ai"],
      description:
        "Viser om virksomhederne handler med private kunder (B2C). Fundet ved hjælp af AI.",
      filterType: filterGroupTypes.label,
      yesLabel: "Handler med private (B2C)",
      noLabel: "Handler ikke med private (B2C)",
      values: ["20924006-0559-4fd4-91e3-cf2ad28354f6"], // "Handler med private (B2C)"
      filters: {
        value: {
          fieldName: "Labels.Labels",
          filterName: "website-label-b2c",
        },
      },
      DisplayValue: ({ filters }) => {
        return createDisplayValue("website-label-b2c", filters);
      },
    }),
    officeEnvironment: createFilterGroup({
      id: "office-environment",
      title: "Overvejende kontormiljø",
      keywords: ["kontor", "arbejdsmiljø", "ai"],
      description:
        "Viser om virksomhederne hovedsageligt opererer i et kontormiljø. Fundet ved hjælp af AI.",
      filterType: filterGroupTypes.label,
      yesLabel: "Skal have kontormiljø",
      noLabel: "Skal ikke have kontormiljø",
      values: ["9de5f146-087b-49a5-b888-64b2c6fe525e"], // "Overvejende kontormiljø"
      filters: {
        value: {
          fieldName: "Labels.Labels",
          filterName: "website-label-office-environment",
        },
      },
      DisplayValue: ({ filters }) => {
        return createDisplayValue("website-label-office-environment", filters);
      },
    }),
    saas: createFilterGroup({
      id: "saas",
      title: "SaaS udbyder",
      keywords: ["software as a service", "cloud", "ai"],
      filterType: filterGroupTypes.label,
      yesLabel: "Skal være SaaS udbyder",
      noLabel: "Skal ikke være SaaS udbyder",
      values: ["4ef115bf-277e-452e-b5d9-28f05e9096da"], // "SaaS udbyder"
      description:
        "Indikerer om virksomhederne udbyder SaaS-løsninger. Fundet ved hjælp af AI.",
      filters: {
        value: {
          fieldName: "Labels.Labels",
          filterName: "website-label-saas",
        },
      },
      DisplayValue: ({ filters }) => {
        return createDisplayValue("website-label-saas", filters);
      },
    }),
  },
} satisfies FilterCategory;
